import { useEffect } from 'react'

import { type ReactFlowState, useStore } from '@xyflow/react'
import { useAtomValue, useSetAtom } from 'jotai'

import {
  applyInsertedNodeShiftAtom,
  pendingInsertedNodeShiftAtom
} from 'Automations/automationEditor/atoms'

/**
 * After a node is inserted inline on an edge, wait for React Flow to measure
 * it, then shift its downstream subtree by the measured width to make room (see
 * applyInsertedNodeShiftAtom). The width is read reactively from the ReactFlow
 * store (where `measured` lives), so the shift applies as soon as it's known.
 * Must be used inside a ReactFlowProvider.
 */
export const useInsertedNodeShift = () => {
  const pending = useAtomValue(pendingInsertedNodeShiftAtom)
  const applyShift = useSetAtom(applyInsertedNodeShiftAtom)

  const measuredWidth = useStore((state: ReactFlowState) =>
    pending ? state.nodeLookup.get(pending.nodeId)?.measured.width : undefined
  )

  useEffect(() => {
    if (!pending || measuredWidth == null) return
    applyShift({ width: measuredWidth })
  }, [pending, measuredWidth, applyShift])
}
